<template>
	<div class="user_wrap">
		
		<div class="top_header">
			<div class="red_top_bg">
				<div class="back_left" @click="$router.back()"></div>
				<div class="big_tit">{{$t('index.lixibao')}}</div>
			</div>
		</div>
		<div class="user_block">
			<div class="user_grid clear">
				<div class="user_grid__item">
					<div class="user_grid__card user_money">
						<p>{{$t('lixibao.title1')}}</p>
						<p>{{data.money}}</p>
					</div>
				</div>
				<div class="user_grid__item">
					<div class="user_grid__card user_money">
						<p>{{$t('lixibao.title2')}}</p>
						<p>{{totaltouru}}</p>
					</div>
				</div>
				<div class="user_grid__item">
					<div class="user_grid__card user_money">
						<p>{{$t('lixibao.title3')}}</p>
						<p>{{totalsouru}}</p>
					</div>
				</div>
				<div class="user_grid__item">
					<div class="user_grid__card user_balance">
						<div>
							{{$t('lixibao.title4')}}
						</div>
						<div>
							{{yestoday}}
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="user_block">
			<div style="color: #ffffff;font-size: 16px;line-height: 50px;">{{$t('lixibao.buytitle')}}</div>
		</div>
		<form class="form">
			<div class="recharge_wrap">
				<div class="form-cell">
					<div class="flex_bd">
						<input v-model.trim="lxb_money" type="number" step="0.01" class="inp" :placeholder="$t('lixibao.moneyMark2')">
					</div>
					<span class="unit">
						{{$t('lixibao.moneyMark')}}
					</span>
				</div>
			</div>
		</form>
		<div class="user_block">
			<div style="color: #ffffff;font-size: 16px;line-height: 50px;">{{$t('lixibao.buytitle2')}}</div>
		</div>
		<div class="user_block" style="padding-top: 0px;">
			<div class="user_grid clear">
				<div class="user_grid__item2" v-for="(item,index) in lxb_data" @click="selLxb(item)">
					<div class="user_grid__card user_money" :class="item.id == selid?'lxbsel':''">
						<p>{{item.title}}</p>
						<p>{{$t('utils.dailyIncome')}} : {{item.bili}} %</p>
						<p>{{$t('utils.cycle')}} : {{item.day}} {{$t('sign.days')}}</p>
						<p>{{$t('utils.startingAmount')}} : {{item.min_num}}</p>
						<p>{{$t('utils.endingAmount')}} : {{item.max_num}}</p>
					</div>
				</div>
			</div>
		</div>
		<div class="basic_btn" @click="submit_lxb">{{$t('utils.submit')}}</div>
		<div class="basic_btn2" @click="$router.push('/lixibaorecord')">{{$t('lixibao.record')}}</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	import qs from 'qs';
	import Fetch from '../../utils/fetch';
	import Api from "../../interface/index";
    import axios from 'axios'
	import {
		Icon,
		Uploader,
		Cell,
		CellGroup,Toast
	} from "vant";

	Vue.use(Cell).use(CellGroup).use(Icon).use(Uploader);

	export default {
		name: "lixibao",
		components: {},
		data() {
			return {
				lang:this.$i18n.locale||"ja_jp",
				data: {},
				eye: 1,
				checked:true,
				show_tz: false,
				fileList: [],
				avatar: '',
				lxb_money: '',
				lxb_data: [],
				selid:0,
				totaltouru: 0,
				totalsouru: 0,
				yestoday: 0
			};
		},
		created() {
			this.$parent.footer('user', false);
		},
		mounted() {
			this.start();
		},
		methods: {
			
			start() {
				Fetch('/user/info').then((r) => {
					this.data = r.data;
				});
				Fetch('/index/getlixibao').then((r) => {
					this.lxb_data = r.data.list;
					this.totaltouru=r.data.totaltouru;
					this.totalsouru=r.data.totalsouru;
					this.yestoday=r.data.yestoday;
				});
			},
			selLxb(row){
				this.selid=row.id;
			},
			submit_lxb(){
				if(!this.lxb_money){
					this.$toast({
						className:"toastName",
						message: this.$t('lixibao.moneyMark2'),
					});
					return false;
				}
				if(!this.selid){
					this.$toast({
						className:"toastName",
						message: this.$t('lixibao.moneyempty'),
					});
					return false;
				}
				Fetch("/index/lxb_apply", {
				  id: this.selid,
				  money:this.lxb_money
				}).then(r => {
					this.$toast({
						className:"toastName",
						message: r.info,
					});
				}).catch(err=>{
				    this.lxb_money = '';
				})
			}
		}
	};
</script>

<style lang="less" scoped>
	.red_top_bg {
		position: relative;
		background: unset;

		.sign {
			position: absolute;
			top: 15px;
			right: 15px;
			height: 20px;

			img {
				height: 100%;
			}
		}
	}


	.user_block {
		padding: 10px 15px;

		.user_kf {
			display: flex;
			align-items: center;
			justify-content: center;
			border-radius: 5px;
			background-image: linear-gradient(to right, #ff5252, #ff8244);
			box-shadow: 2px 2px 5px rgba(115, 115, 115, 0.35);
			color: #fff;
			font-size: 12px;
			padding: 10px;

			img {
				width: 27px;
				height: 27px;
				margin-right: 8px;
			}
		}

		.user_grid {
			margin: 0px;
			background-color: #1d0554;
			padding:10px 0 1px;

			.user_grid__item {
				float: left;
				width: 50%;
				padding: 0 7.5px;
				box-sizing: border-box;
				
				.user_grid__card {
					//border: 1px solid #eeeeee;
					background-color: #2a1164;
					border-radius: 5px;
					//box-shadow: 2px 2px 5px rgba(115, 115, 115, 0.35);
					margin-bottom: 10px;
					text-align: center;
					padding: 12px;
					&.lxbsel{
						background-color: #4a20ac;
					}
				}

				.user_money {
					p:nth-child(1) {
						font-size: 14px;
						color: #ffffff;
					}

					p:nth-child(2) {
						font-size: 16px;
						color: #ef5040;
						margin-top: 8px;
					}
					p:nth-child(3) {
						color: #ffffff;
						line-height: 30px;
					}
				}

				.user_balance {
					div:nth-child(1) {
						font-size: 14px;
						color: #ffffff;
					}

					div:nth-child(2) {
						font-size: 18px;
						color: #ef5040;
						margin-top: 8px;
					}
				}
			}

			.user_grid__item2 {
				padding: 0 7.5px;
				box-sizing: border-box;
				margin-bottom: 10px;
				.user_grid__card {
					//border: 1px solid #eeeeee;
					background-color: #2a1164;
					border-radius: 5px;
					//box-shadow: 2px 2px 5px rgba(115, 115, 115, 0.35);
					color:#ffffff;
					//text-align: center;
					padding: 12px;
					display: flex;
					flex-wrap: wrap;
					&.lxbsel{
						background-color: #4a20ac;
					}
					p{
						width: 50%;
						color: #ffffff;
						line-height: 30px;
					}
				}

				.user_money {
					p:nth-child(1) {
						width: 100%;
						font-size: 18px;
						border-bottom: solid 1px #36187d;
						padding-bottom: 10px;
					}
				}
			}
		}
	}


	.user_wrap {
		max-width: 100%;
		overflow: hidden;
		padding-bottom: 20px;
		background-color: #250767;
	}

	.top_header {
		position: relative;
		width: 100%;
		//height: 90px;
		//background-image: url(../images/user/user_bg.jpg);
		//background-position: center;
		//background-repeat: no-repeat;
		//background-size: 100% 100%;

		.user_detail {
			//width: 100%;
			padding: 28px 15px 0;
			.user_header {
				width: 48px;
				height: 48px;
				overflow: hidden;
				//margin: 0 auto;
				border-radius: 50%;
				float: left;

				img {
					width: 100%;
					height: 100%;
					border: 2px solid #FFFFFF;
					border-radius: 30px;
				}
			}

			.user_name {
				margin-top: 5px;
				color: #FFFFFF;
				//text-align: center;
				float: left;
				padding-left: 15px;

				.user_all {

					.user_nickname {
						line-height: 22px;
						font-size: 15px;
						font-weight: bold;
					}
					
					.user_vip {
						color: #FFFFFF;
						text-align: center;
						//padding: 8px 15px;

						.vip-box {
							position: relative;
							text-align: center;
							font-size: 12px;
							min-width: 45px;
							padding: 0 14px;
							line-height: 15px;
							border-radius: 8px;
							display: inline-block;
							background-image: linear-gradient(to right, #ffa51e, #ffe462);

							.vip-badge {
								position: absolute;
								left: -8px;
								top: -2.5px;
								width: 20px;
								height: 20px;
								background-image: url(../images/user/badge.png);
								background-position: center;
								background-repeat: no-repeat;
								background-size: 100% 100%;
							}
						}
					}
				}
			}
			.msg{float: right;}
		}


		.user_balance {
			text-align: center;

			div {
				margin: 10px 0;
			}

			div:nth-child(1) {
				font-size: 14px;
				color: #d3d5d6;
			}

			div:nth-child(2) {
				font-weight: bold;
				font-size: 18px;
				color: #FFFFFF;
			}
		}

		.user_money {
			display: flex;
			justify-content: space-between;
			text-align: center;

			p {
				margin: 10px 0;
			}

			div {
				width: 33.33%;
			}

			p:nth-child(1) {
				font-size: 14px;
				color: #d3d5d6;
			}

			p:nth-child(2) {
				font-size: 14px;
				color: #FFFFFF;
			}
		}
	}


	.form {

		.recharge_wrap {
			padding: 0 15px;

			.form-cell {
				padding: 10px;
				background: rgba(255, 255, 255, 1);
				border-radius: 5px;
				box-shadow: 2px 2px 5px rgba(115, 115, 115, .35);
				display: flex;
				align-items: center;
				background-color: #FFF;

				.flex_bd {
					flex: 1;

					input {
						height: 25px;
						width: 100%;
						line-height: 25px;
						font-size: 14px;
					}
				}

				.unit {
					color: #666666;
					display: flex;
					align-items: center;
					font-size: 12px;

					img {
						width: 16px;
						height: 16px;
						margin-right: 5px;
					}
				}
			}

			div:nth-child(2) {
				text-align: right;
				color: #666666;
				margin-top: 8px;
			}
		}

		.tit {
			border-bottom: 1px solid #ebe9e9;
			font-size: 16px;
			padding: 15px;
			color: #ffffff;
		}

		.item {
			height: 40px;
			border-bottom: 1px solid #ECECEC;
			display: flex;
			justify-content: flex-start;
			align-items: center;

			&:last-child {
				border-bottom: none;
			}

			.check {
				width: 16px;
				height: 16px;
				margin-left: 4px;
				background: url(../images/user/c2.png) no-repeat center center;
				background-size: 100% 100%;

				&.checked {
					background: url(../images/user/c1.png) no-repeat center center;
					background-size: 100% 100%;
				}
			}

			.re_icon {
				width: 20px;
				height: 20px;
				margin-right: 5px;

				img {
					width: 20px;
					height: 20px;
				}
			}

			.re_name {
				font-size: 12px;
				flex: 1;
				line-height: 22px;
				color: #333333;
				margin-left: 4px;
			}

			.wx {
				background: url(../images/user/recharge3.png) no-repeat center center;
				background-size: 100% 100%;
			}

			.alipay {
				background: url(../images/user/recharge2.png) no-repeat center center;
				background-size: 100% 100%;
			}

			.usdt {
				background: url(../images/user/recharge1.png) no-repeat center center;
				background-size: 100% 100%;
			}

			.alipay_app {
				background: url(../images/user/recharge2.png) no-repeat center center;
				background-size: 100% 100%;
			}

			.bank {
				background: url(../images/user/recharge4.png) no-repeat center center;
				background-size: 100% 100%;
			}
		}
	}
	
	.basic_btn {
		//width: 213px;
		height: 35px;
		line-height: 35px;
		font-size: 12px;
		margin: 0 auto;
	}
	.basic_btn2 {
		height: 35px;
		line-height: 35px;
		font-size: 12px;
		width: 90%;
		margin: 10px auto;
		background: #492599;
		border-radius: 23px;
		color: #FFFFFF;
		text-align: center;
	}
</style>
